import React from 'react';
import { useIsEmbeddedMobile } from '../../../../../../../_hooks/useIsEmbeddedMobile';
import { RealizedGainLossDTO } from '../../../../../../api/useRealizedGainLossQuery';
import { DesktopTotals } from './components/DesktopTotals/DesktopTotals';
import { MobileTotals } from './components/MobileTotals/MobileTotals';

interface Props {
  realizedGainsLossDataList?: RealizedGainLossDTO[];
}

export const Totals = ({ realizedGainsLossDataList }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  const gainLossList = (realizedGainsLossDataList || []).reduce(
    (acc, gainLoss) => {
      return {
        ...acc,
        shortTerm: acc.shortTerm + gainLoss.shortTerm,
        longTerm: acc.longTerm + gainLoss.longTerm,
        total: acc.total + gainLoss.total,
      };
    },
    {
      shortTerm: 0,
      longTerm: 0,
      total: 0,
    },
  );

  if (isEmbeddedMobile) {
    return <MobileTotals {...gainLossList} />;
  }

  return <DesktopTotals {...gainLossList} />;
};
